const patterns = {
  'account_id'  : new RegExp(/^\d+$/),
  'vat_id'      : new RegExp(/^[A-Z]{2}?[0-9]{10}$/),
  'email'       : new RegExp(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/),
  'decimal'     : new RegExp(/^(\d+\.?\d{0,9}|\.\d{1,9})$/),
  'phone'       : new RegExp(/^[0-9]{9}$/),
};

const examples = {
  'post_code' : 'xx-xxx',
  'vat_id'    : 'XX1234567890',
  'email'     : 'example@example.com',
  'required'  : 'Pole wymagane',
  'decimal'   : '12,22',
  'phone'     : 'Podaj numer w postaci xxxyyyzzz',
};

class validatorDirective{
  constructor(){
    'ngInject';
    this.restrict = 'A';
  }

  /**
   *
   * @param scope
   * @param element
   * @param attribute
   */
  link( scope, element, attribute ){

    try{
      let validator     = attribute.validator,
          pattern       = patterns[validator],
          formGroup     = element.parent().hasClass('form-group') ? element.parent() : element.parent().parent(),
          label         = formGroup.find('label'),
          labelText     = null,
          errorText     = examples[validator],
          isRequired    = attribute.required;


      element.on('keyup focus blur change', (event) => {

        let value       = event.currentTarget.value,
            // valid       = validator === 'required' ? !!value.length : pattern.test(value);
            valid       = validator === 'required' ? (!!value.length && value !== '?') :
                validator === 'account_id' && (value.length === 0 || !pattern.test(value)) ? false :
                validator === 'decimal_optional' ? (value.length > 0 ? pattern.test(value) : true) :
                validator === 'decimal' ? (value.length > 0 ? pattern.test(value) : false) :
                    value.length > 0 ? pattern.test(value) : true;

        if( attribute.min && parseInt(value) < parseInt(attribute.min) ){
          event.currentTarget.value = attribute.min;
        }

        if( attribute.max && parseInt(value) > parseInt(attribute.max) ){
          event.currentTarget.value = attribute.max;
        }

        if( !labelText ){
          labelText = label.text();
        }

        if( valid ){
          formGroup.find('.label-has-error').remove();
          formGroup
            .prepend(label)
            .removeClass('has-error');
        } else {
          formGroup.find('label').remove();
            formGroup.prepend(`
              <label class="label-has-error">
                <span>${labelText}</span><br>
                <small>${errorText}</small>
              </label>
            `);
            formGroup
              .addClass('has-error');
        }

      });
    } catch( e ) {
      console.log( e );
    }
  }

  static create(){
    return new validatorDirective();
  }

}

export { validatorDirective };


/** WEBPACK FOOTER **
 ** ./frontend/components/active/validator/validator.directive.js
 **/